/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ items: NonNullable<unknown> }} Spaces_Confirm_Delete_Selected_DescriptionInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to delete {items}? This action cannot be undone." |
*
* @param {Spaces_Confirm_Delete_Selected_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_confirm_delete_selected_description = /** @type {((inputs: Spaces_Confirm_Delete_Selected_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Confirm_Delete_Selected_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Möchten Sie ${i?.items} wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.`)
	return /** @type {LocalizedString} */ (`Are you sure you want to delete ${i?.items}? This action cannot be undone.`)
});